// global ENV object
// that can be used to dynamically change env values
// (e.g. when loading google storage bucket from backend)
// the /api/v1/env route will populate this
const ENV: Record<string, string> = {}
export default ENV